import { type QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"

import { Footer } from "@/components/layout/Footer"
import { Header } from "@/components/layout/Header"
import { ScrollToTop } from "@/components/layout/ScrollToTop"

/**
 * The root route. Everything renders inside this Outlet.
 *
 * `createRootRouteWithContext` types the router context, so `queryClient` is
 * available and typed in every loader below — which is what lets a route
 * prefetch its data before rendering.
 */
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
	component: RootLayout,
	notFoundComponent: () => <p>Page not found.</p>,
})

function RootLayout() {
	return (
		<div className="bg-surface text-on-surface selection:bg-primary-fixed selection:text-primary flex min-h-screen w-full flex-col">
			<Header />
			<main className="w-full flex-1 pt-24">
				<Outlet />
			</main>
			<Footer />
			<ScrollToTop />
		</div>
	)
}
